import script from "./DocumentReviewing.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentReviewing.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentReviewing.vue?vue&type=style&index=0&id=c684e17e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c684e17e"]])

export default __exports__